/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */

import { KeyLookup, TableColumnDef, TABLE_KEY_ACTION } from "./table";

export const ORDER_STATUS = {
  BackOrdered: "B",
  Submitted: "I",
  Approved: "M",
  NoInventory: "L",
  ApprovalDenied: "N",
  PendingOrder: "P",
  Released: "R",
  Shipped: "S",
  PendingApproval: "W",
  Canceled: "X",
  PaymentApproved: "C",
};

export const DIALOG_ACTION = {
  CancelOrder: "CancelOrder",
  ReOrder: "ReOrder",
  LockAndContinueReOder: "LockAndContinueReOrder",
};

export const CSR_LOCK_ORDER = "LOCK_ORDER_ACTION";

export const ORDER_LOCK_MESSAGE_KEY = "_ERR_ORDER_IS_LOCKED";
export const ORDER_NOT_LOCK_MESSAGE_KEY = "_ERR_ORDER_IS_NOT_LOCKED";
//emerald fetch cart
export const CART_FETCHING_REQUESTED = "CART_FETCHING_REQUESTED";
export const PATH_CART = "/cart";

export const ORDERID = "orderId";
export const ORDERTIME = "orderTime";
export const ADDRESS = "uniqueShippingAddresses.0.address1";
export const RECIPIENT = "uniqueShippingAddresses.0.firstName+uniqueShippingAddresses.0.lastName";
export const LOGINID = "buyer.logonId";
export const STATUS = "status";

export const ORDER_STATS = [
  {
    key: "F",
    value: "Confirmado",
  },
  {
    key: "G",
    value: "Confirmado",
  },
  {
    key: "H",
    value: "Confirmado",
  },
  {
    key: "X",
    value: "Cancelado",
  },
  {
    key: "C",
    value: "Pagado",
  },
  {
    key: "M",
    value: "Pendiente de pago",
  },
];
export const ORDER_SEARCH_TABLE_COLUMNS: TableColumnDef[] = [
  {
    title: "OrderManagement.OrderNumber",
    idProp: "orderId",
    keyLookup: {
      key: ORDERID,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "OrderManagement.OrderDate",
    idProp: "orderId",
    keyLookup: {
      key: ORDERTIME,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "OrderManagement.ShippingAddress",
    idProp: "orderId",
    keyLookup: {
      key: ADDRESS,
    } as KeyLookup,
    sortable: false,
  },
  {
    title: "OrderManagement.CustomerName",
    idProp: "orderId",
    keyLookup: {
      key: RECIPIENT,
    } as KeyLookup,
    sortable: false,
  },
  {
    title: "OrderManagement.LogonIdEmail",
    idProp: "orderId",
    keyLookup: {
      key: LOGINID,
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "OrderManagement.StatusTableHeader",
    idProp: "orderId",
    keyLookup: {
      key: STATUS,
      translateKeyPrefix: "OrderManagement.Status.",
    } as KeyLookup,
    sortable: true,
  },
  {
    title: "",
    idProp: "orderId",
    keyLookup: {
      key: TABLE_KEY_ACTION,
      translateKeyPrefix: "Table.Actions.",
    } as KeyLookup,
    sortable: false,
  },
];

export const ORDER_SEARCH_TABLE_ACTION = {
  ACCESS_ACCOUNT: "accessAcount",
  ENABLE_DISABLE_ACCOUNT: "enableDisableAccount",
  LOCK_UNLOCK_ORDER: "lockUnlockOrder",
  VIEW_ORDER: "viewOrder",
};

export const ORDER_SEARCH_TABLE_ACTIONS: string[] = [
  ORDER_SEARCH_TABLE_ACTION.ACCESS_ACCOUNT,
  ORDER_SEARCH_TABLE_ACTION.ENABLE_DISABLE_ACCOUNT,
  ORDER_SEARCH_TABLE_ACTION.LOCK_UNLOCK_ORDER,
  ORDER_SEARCH_TABLE_ACTION.VIEW_ORDER,
];
//lock order error
export const TAKE_OVER_LOCK_ERROR = "_ERR_ORDER_IS_LOCKED";
export const LOCK_ORDRE_ERROR = ["_ERR_ORDER_IS_NOT_LOCKED", TAKE_OVER_LOCK_ERROR];

export const SORT_ORDER_NUMBER_ASC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "orders_id",
};
export const SORT_ORDER_NUMBER_DESC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "orders_id DESC",
};
export const SORT_ORDER_DATE_ASC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "TIMEPLACED",
};
export const SORT_ORDER_DATE_DESC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "TIMEPLACED DESC",
};
export const SORT_FIRST_NAME_ASC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "firstname",
};
export const SORT_FIRST_NAME_DESC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "firstname DESC",
};
export const SORT_ADDRESS_ASC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "address1",
};
export const SORT_ADDRESS_DESC = {
  orderByTableName: "ADDRESS",
  orderByFieldName: "address1 DESC",
};
export const SORT_LOGONID_ASC = {
  orderByTableName: "USERREG",
  orderByFieldName: "logonid",
};
export const SORT_LOGONID_DESC = {
  orderByTableName: "USERREG",
  orderByFieldName: "logonid DESC",
};
export const SORT_STATUS_ASC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "status",
};
export const SORT_STATUS_DESC = {
  orderByTableName: "ORDERS",
  orderByFieldName: "status DESC",
};

export const ORDER_STATE_CREATED = 0;
export const ORDER_STATE_CANCELLED = 1;
export const ORDER_STATE_CONFIRMED = 2;

export const ORDER_STATE_BY_ID = {
  0: "Creado",
  1: "Cancelado",
  2: "Confirmado",
};

export const ORDER_PAYMENT_STATES = [
  {
    id: 0,
    name: "No pagado",
    key: "PAYMENT_STATUS_NOTPAID",
  },
  {
    id: 1,
    name: "Parcialmente pagado",
    key: "PAYMENT_STATUS_PAID",
  },
  {
    id: 2,
    name: "Pagado",
    key: "PAYMENT_STATUS_PARTPAID",
  },
];

export const ORDER_PAYMENT_BY_ID = {
  0: ORDER_PAYMENT_STATES[0],
  1: ORDER_PAYMENT_STATES[1],
  2: ORDER_PAYMENT_STATES[2],
};

export const ORDER_SHIPPING_STATES = [
  {
    id: 0,
    name: "No enviado",
    key: "SHIPPING_STATUS_NOTSHIPPED",
  },
  {
    id: 1,
    name: "Parcialmente enviado",
    key: "SHIPPING_STATUS_PARTSHIPPED",
  },
  {
    id: 2,
    name: "Enviado",
    key: "SHIPPING_STATUS_SHIPPED",
  },
];

export const ORDER_SHIPPING_BY_ID = {
  0: ORDER_SHIPPING_STATES[0],
  1: ORDER_SHIPPING_STATES[1],
  2: ORDER_SHIPPING_STATES[1],
};

export const ORDER_STATUS_FILTER = [
  {
    id: "0",
    name: "No procesado",
    key: "ORDER_STATUS_FILTER_NOT_PROCESSED",
  },
  {
    id: "1,2",
    name: "Procesado",
    key: "ORDER_STATUS_FILTER_PROCESSED",
  },
];

export const ORDER_STATUS_FILTER_BY_ID = {
  0: ORDER_STATUS_FILTER[0],
  1: ORDER_STATUS_FILTER[1],
};

export const ORDER_ITEM_STATUS = [
  {
    id: 0,
    name: "Recibido en tienda", //botones aqui
  },
  {
    id: 1,
    name: "Pendiente de notificar al courier",
  },
  {
    id: 2,
    name: "Notificado al courier",
  },
  {
    id: 3,
    name: "Cancelado",
  },
];

export const ORDER_ITEM_STATUS_RECEIVED = 0;
export const ORDER_ITEM_STATUS_CANCELLED = 3;

export const ORDER_ITEM_STATUS_BY_ID = {
  0: ORDER_ITEM_STATUS[0],
  1: ORDER_ITEM_STATUS[1],
  2: ORDER_ITEM_STATUS[2],
  3: ORDER_ITEM_STATUS[3],
};

export const ORDER_DROPDOWN_PARAMETERS = [
  { id: 0, name: "Seleccionar" },
  { id: 1, name: "Número de pedido" },
  { id: 2, name: "ID de cliente" },
  { id: 3, name: "Nombre y Apellido" },
  { id: 4, name: "Correo electrónico" },
  { id: 5, name: "País y Ciudad" },
];
